import { rem } from 'polished'

export const typeScale = {
  '100': rem('16px'),
  '200': rem('20px'),
  '300': rem('24px'),
  '400': rem('32px'),
  '500': rem('40px'),
}
